export default "__VITE_ASSET__21cf0857__"